export const portfolioWorks = [
  {
    id: 1,
    title: '品牌视觉设计系统',
    category: '海报设计',
    date: '2025-07-08',
    tools: ['Illustrator', 'Photoshop'],
    description: '为某科技公司设计的完整品牌视觉识别系统，包含Logo设计、色彩规范、字体系统和应用场景展示。整体风格简洁现代，强调科技感与专业性。',
    coverImage: 'https://readdy.ai/api/search-image?query=modern%20brand%20visual%20identity%20design%20system%20showcase%20with%20clean%20logo%20and%20color%20palette%20presentation%20on%20white%20background%2C%20professional%20brand%20guidelines%20layout%2C%20minimalist%20design%20aesthetic%20with%20organized%20brand%20elements%20display%2C%20geometric%20shapes%20and%20typography%20samples&width=600&height=800&seq=portfolio-detail-001&orientation=portrait',
  },
  {
    id: 2,
    title: '电商产品精修合成',
    category: '图像精修',
    date: '2025-07-05',
    tools: ['Photoshop'],
    description: '高端化妆品产品图精修项目，包含去背景、光影重塑、质感增强、倒影合成等多个环节。通过精细的修图技巧，让产品呈现出商业级的视觉效果。',
    coverImage: 'https://readdy.ai/api/search-image?query=professional%20cosmetic%20product%20photography%20retouching%20showcase%2C%20high-end%20beauty%20product%20on%20clean%20white%20background%20with%20perfect%20lighting%20and%20reflections%2C%20commercial%20photography%20quality%20with%20enhanced%20texture%20and%20details&width=600&height=400&seq=portfolio-detail-002&orientation=landscape',
    beforeImage: 'https://readdy.ai/api/search-image?query=raw%20unedited%20cosmetic%20product%20photo%20with%20rough%20lighting%20and%20plain%20background%2C%20before%20retouching%20state%2C%20natural%20photography%20without%20enhancement&width=800&height=600&seq=portfolio-before-002&orientation=landscape',
    afterImage: 'https://readdy.ai/api/search-image?query=professionally%20retouched%20cosmetic%20product%20with%20perfect%20lighting%20and%20clean%20background%2C%20after%20retouching%20state%2C%20commercial%20quality%20with%20enhanced%20details%20and%20reflections&width=800&height=600&seq=portfolio-after-002&orientation=landscape',
  },
  {
    id: 3,
    title: '概念海报设计',
    category: '海报设计',
    date: '2025-06-22',
    tools: ['Photoshop', 'Illustrator'],
    description: '音乐节主题概念海报，采用大胆的色彩搭配和动感的版式设计。通过几何图形与渐变色的结合，营造出强烈的视觉冲击力和现代感。',
    coverImage: 'https://readdy.ai/api/search-image?query=creative%20music%20festival%20conceptual%20poster%20design%20with%20bold%20typography%20and%20vibrant%20gradient%20colors%2C%20modern%20graphic%20design%20artwork%20with%20abstract%20geometric%20shapes%2C%20contemporary%20art%20style%20poster%20with%20dynamic%20composition&width=600&height=900&seq=portfolio-detail-003&orientation=portrait',
  },
  {
    id: 4,
    title: 'AI生成视觉实验',
    category: 'AI视觉实验',
    date: '2025-06-15',
    tools: ['Stable Diffusion', 'Photoshop'],
    description: '使用AI工具进行的视觉创作实验，探索人工智能在艺术创作中的可能性。通过多次迭代和后期调整，创造出独特的超现实主义风格作品。',
    coverImage: 'https://readdy.ai/api/search-image?query=artificial%20intelligence%20generated%20surreal%20digital%20art%20with%20neural%20network%20patterns%2C%20futuristic%20AI%20artwork%20with%20abstract%20technological%20visualization%2C%20vibrant%20colors%20and%20flowing%20organic%20forms%2C%20cyberpunk%20aesthetic&width=600&height=600&seq=portfolio-detail-004&orientation=squarish',
  },
  {
    id: 5,
    title: '移动应用界面设计',
    category: 'UI练习',
    date: '2025-05-20',
    tools: ['Figma', 'Illustrator'],
    description: '健康管理类移动应用的UI设计练习，包含首页、数据统计、个人中心等多个页面。采用清新的配色方案和友好的交互设计，注重用户体验。',
    coverImage: 'https://readdy.ai/api/search-image?query=modern%20mobile%20health%20app%20UI%20design%20mockup%20on%20smartphone%20screen%20with%20clean%20interface%20and%20gradient%20colors%2C%20user-friendly%20app%20layout%20with%20data%20visualization%2C%20contemporary%20mobile%20design%20aesthetic%20with%20soft%20shadows&width=600&height=800&seq=portfolio-detail-005&orientation=portrait',
  },
  {
    id: 6,
    title: '短视频片头动画',
    category: '视频片头',
    date: '2025-05-10',
    tools: ['After Effects', 'Premiere Pro'],
    description: '为品牌宣传视频设计的动态片头，时长5秒。通过粒子效果、光效和动态文字的组合，营造出科技感和专业感，有效提升品牌形象。',
    coverImage: 'https://readdy.ai/api/search-image?query=dynamic%20video%20intro%20animation%20frame%20with%20particles%20and%20light%20effects%2C%20motion%20graphics%20design%20with%20glowing%20elements%2C%20cinematic%20title%20sequence%20with%20modern%20video%20production%20aesthetic%2C%20tech%20style%20visual%20effects&width=600&height=400&seq=portfolio-detail-006&orientation=landscape',
  },
  {
    id: 7,
    title: '插画角色设计',
    category: '海报设计',
    date: '2025-04-28',
    tools: ['Illustrator', 'Procreate'],
    description: '扁平风格的卡通角色设计，用于儿童教育类产品。角色造型可爱友好，色彩明快温暖，符合目标用户群体的审美偏好。',
    coverImage: 'https://readdy.ai/api/search-image?query=cute%20character%20illustration%20design%20in%20flat%20style%20with%20bright%20warm%20colors%2C%20colorful%20vector%20character%20with%20friendly%20personality%20and%20simple%20shapes%2C%20modern%20digital%20illustration%20aesthetic%20for%20children%20education&width=600&height=700&seq=portfolio-detail-007&orientation=portrait',
  },
  {
    id: 8,
    title: '网页视觉设计',
    category: 'UI练习',
    date: '2025-04-12',
    tools: ['Figma', 'Photoshop'],
    description: '企业官网首页视觉设计，采用大屏设计思路。通过渐变背景、卡片式布局和精致的图标设计，打造出现代化的企业形象展示平台。',
    coverImage: 'https://readdy.ai/api/search-image?query=modern%20website%20landing%20page%20design%20mockup%20with%20hero%20section%20and%20gradient%20background%2C%20clean%20web%20interface%20with%20card%20layout%2C%20professional%20website%20design%20with%20icons%20and%20imagery%2C%20contemporary%20web%20design%20aesthetic&width=600&height=500&seq=portfolio-detail-008&orientation=landscape',
  },
  {
    id: 9,
    title: '美食摄影后期处理',
    category: '图像精修',
    date: '2025-03-25',
    tools: ['Photoshop', 'Lightroom'],
    description: '餐厅菜品摄影的后期精修，包含色彩校正、质感增强、背景虚化等处理。通过专业的修图技巧，让食物看起来更加诱人可口。',
    coverImage: 'https://readdy.ai/api/search-image?query=professional%20food%20photography%20retouching%20with%20enhanced%20colors%20and%20textures%2C%20delicious%20restaurant%20dish%20on%20clean%20background%20with%20perfect%20lighting%2C%20commercial%20food%20photography%20quality%20with%20appetizing%20presentation&width=600&height=600&seq=portfolio-detail-009&orientation=squarish',
    beforeImage: 'https://readdy.ai/api/search-image?query=raw%20unedited%20food%20photo%20with%20natural%20lighting%20and%20plain%20setup%2C%20before%20retouching%20state%2C%20simple%20restaurant%20dish%20photography%20without%20enhancement&width=800&height=600&seq=portfolio-before-009&orientation=landscape',
    afterImage: 'https://readdy.ai/api/search-image?query=professionally%20retouched%20food%20photo%20with%20enhanced%20colors%20and%20perfect%20lighting%2C%20after%20retouching%20state%2C%20commercial%20quality%20with%20appetizing%20details%20and%20vibrant%20presentation&width=800&height=600&seq=portfolio-after-009&orientation=landscape',
  },
  {
    id: 10,
    title: '时尚杂志排版设计',
    category: '海报设计',
    date: '2025-03-08',
    tools: ['InDesign', 'Photoshop'],
    description: '时尚杂志内页排版设计练习，注重文字与图片的平衡关系。通过网格系统和留白处理，营造出高端时尚的阅读体验。',
    coverImage: 'https://readdy.ai/api/search-image?query=fashion%20magazine%20layout%20design%20with%20elegant%20typography%20and%20high-end%20photography%2C%20modern%20editorial%20design%20with%20grid%20system%20and%20white%20space%2C%20sophisticated%20magazine%20spread%20with%20luxury%20aesthetic&width=600&height=400&seq=portfolio-detail-010&orientation=landscape',
  },
  {
    id: 11,
    title: 'Logo动效设计',
    category: '视频片头',
    date: '2025-02-18',
    tools: ['After Effects'],
    description: '品牌Logo的动态演绎设计，时长3秒。通过流畅的动画过渡和细腻的缓动曲线，让静态Logo焕发生命力，增强品牌记忆点。',
    coverImage: 'https://readdy.ai/api/search-image?query=animated%20logo%20reveal%20motion%20graphics%20with%20smooth%20transitions%20and%20light%20effects%2C%20dynamic%20brand%20logo%20animation%20frame%2C%20modern%20motion%20design%20with%20elegant%20movement%20and%20particles&width=600&height=600&seq=portfolio-detail-011&orientation=squarish',
  },
  {
    id: 12,
    title: 'AI辅助场景合成',
    category: 'AI视觉实验',
    date: '2025-01-30',
    tools: ['Stable Diffusion', 'Photoshop'],
    description: '结合AI生成和传统合成技术创作的超现实场景。先用AI生成基础元素，再通过Photoshop进行精细合成和调色，最终呈现出梦幻般的视觉效果。',
    coverImage: 'https://readdy.ai/api/search-image?query=surreal%20fantasy%20scene%20composition%20with%20AI%20generated%20elements%2C%20dreamlike%20landscape%20with%20floating%20islands%20and%20magical%20lighting%2C%20photorealistic%20digital%20art%20with%20ethereal%20atmosphere%20and%20vibrant%20colors&width=600&height=800&seq=portfolio-detail-012&orientation=portrait',
  },
];

export const portfolioCategories = [
  { name: '全部', count: 12 },
  { name: '海报设计', count: 4 },
  { name: '图像精修', count: 2 },
  { name: 'UI练习', count: 2 },
  { name: '视频片头', count: 2 },
  { name: 'AI视觉实验', count: 2 },
];